import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Snackbar} from '@material-ui/core';

import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';

const useStyles = makeStyles({
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    previewChip: {
        minWidth: 100,
        maxWidth: 150,
    },
    input: {
        width: '200px',
        height: '80px',
    },
    errorMsg: {
        marginTop: '10px',
        height: '30px',
        fontSize: '12px',
        color: '#f44336',
        fontFamily: 'Roboto',
        fontWeight: 400,
    },
    btn: {
        borderRadius: '20px',
        height: '40px',
        textTransform: 'none',
    },
    passwordInput: {
        margin: '0 24px 0 14px',
        width: '200px',
        height: '70px',
    },
    resize: {
        fontSize: '14px',
    },
});

export interface IError {
    status: string;
    message: string;
    codeError: number | null;
}

interface IOpenData {
    responseStatus: any;
    isSnackbarOpen: boolean;
    handleCloseSnackbar: (event?: React.SyntheticEvent, reason?: string) => void;
}

const Notice = (props: IOpenData): React.JSX.Element => {
    const {responseStatus, isSnackbarOpen, handleCloseSnackbar} = props;

    function Alert(props: AlertProps) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
        <Snackbar open={isSnackbarOpen} autoHideDuration={responseStatus.status === 'error' ? 100000 : 4000} onClose={handleCloseSnackbar}>
            <Alert onClose={handleCloseSnackbar} severity={responseStatus.status}>
                {responseStatus.status === 'error'
                    ? `${responseStatus.message} Код: ${responseStatus.codeError}`
                    : responseStatus.message
                      ? `${responseStatus.message}`
                      : `Операция прошла успешно.`}
            </Alert>
        </Snackbar>
    );
};

export default Notice;
